import api, { ResponsePayloadWithData } from '.';

export type MediaContentType = {
  id: string;
  name: string;
  category?: string;
  used: number;
};

export const fetchMediaContentTypes = async ({
  moduleId,
  includeSubModules = false,
}: {
  moduleId: string;
  includeSubModules?: boolean;
}) => {
  const { data } = await api.get<ResponsePayloadWithData<MediaContentType[]>>(
    `studio/modules/${moduleId}/media-content-types/usage`,
    {
      params: {
        ...(includeSubModules ? { includeSubModules } : {}),
      },
    },
  );

  return data;
};
